module.exports = __webpack_public_path__ + "img/menu3_mobile.deaefe56.png";